import { mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Fibrus from '@propertypal/shared/src/resources/logos/fibrus.svg';
import styled from 'styled-components';

export const Content = styled.div<{ isFeaturedDevelopment: boolean }>`
  padding-bottom: 30px;
  margin: 30px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  ${({ isFeaturedDevelopment }) =>
    isFeaturedDevelopment &&
    `
    p b,
    p a,
    p button {
      color: inherit;
    }
  `}
`;

export const Title = styled.h2<{ $small: boolean }>`
  display: inline-block;
  padding: 6px 10px;
  font-size: ${($small) => ($small ? 20 : 18)}px;
  background-color: rgba(0, 0, 0, 0.05);
  color: ${({ theme }) => theme.textDark};
  border-radius: 4px;
`;

export const KeyInfoGrid = styled.div<{ $small: boolean }>`
  display: grid;
  grid-template-columns: repeat(${({ $small }) => ($small ? 2 : 3)}, minmax(0, 1fr));
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  margin-top: 15px;

  @media (${tabletMax}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export const KeyInfoItem = styled.div`
  display: flex;
  align-items: flex-start;

  & > svg {
    margin-right: 10px;
  }

  svg {
    color: inherit;
  }
`;

export const KeyInfoTitle = styled.p`
  color: ${({ theme }) => theme.textDark};
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 18px;

  button {
    display: inline-flex;
    color: ${({ theme }) => theme.primary};
  }
`;

export const KeyInfoText = styled.p`
  color: ${({ theme }) => theme.textLight};
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px;

  button,
  a {
    display: inline-flex;
    font-size: 16px;
    color: ${({ theme }) => theme.primary};
    text-decoration: underline;

    svg {
      font-size: 16px;
    }
  }

  b {
    color: ${({ theme }) => theme.primary};
  }
`;

export const CoownershipText = styled.p`
  color: ${({ theme }) => theme.textLight};

  b {
    color: ${({ theme }) => theme.primary};
  }
`;

export const KeyInfoLoader = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
`;

export const SubText = styled.p<{ $small: boolean }>`
  color: ${({ theme }) => theme.backgroundMid};
  font-size: ${($small) => ($small ? 14 : 12)}px;

  button {
    color: ${({ theme }) => theme.primary};
    text-decoration: underline;
  }
`;

export const BottomRow = styled.div`
  background-color: ${({ theme }) => theme.backgroundLightest};
  padding: 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 30px 0;

  p {
    color: ${({ theme }) => theme.textLight};
  }

  a {
    color: ${({ theme }) => theme.red};
    text-decoration: underline;
  }

  @media (${tabletMax}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const KeyInfoLegalFees = styled.a`
  display: block;
  align-items: center;
  gap: 10px;
  margin-top: 10px;

  span {
    font-size: 12px;
    max-width: 120px;
  }
`;

export const LegalLogo = styled.img`
  display: block;
  max-height: 24px;
  margin-left: 5px;
  cursor: pointer;
`;

export const PremierBannerContainer = styled.div<{ isFeaturedDevelopment: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme, isFeaturedDevelopment }) =>
    isFeaturedDevelopment ? 'rgba(0,0,0,0.05)' : theme.primaryTranslucent};
  padding: 16px;
  border-radius: 4px;
  gap: 16px;
  margin-top: 20px;

  a {
    width: 260px;
    justify-items: flex-end;
  }

  @media (${tabletMax}) {
    flex-direction: column;
    align-items: flex-start;

    a {
      width: 210px;
      margin-left: 36px;
    }
  }
`;

export const KeyInfoFibrus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-top: 10px;
  cursor: pointer;

  span {
    font-size: 12px;
    margin-bottom: -5px;
  }
`;

export const FibrusLogo = styled(Fibrus)`
  width: 100%;
  max-width: 82px;
`;
